var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.submitIng),expression:"submitIng"}],attrs:{"type":"primary","size":"small"},on:{"click":_vm.toHandle}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }